(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const checkoutButton = document.querySelector("#checkout"); // Select checkout button
    const cartFooter = document.createElement("div"); // Create the sticky footer
    cartFooter.classList.add("cart-footer");

    // Clone elements
    const totals = document.querySelector(".totals").cloneNode(true);
    const footerCheckoutButton = checkoutButton.cloneNode(true);
    footerCheckoutButton.id = "checkout-footer"; // Unique ID for the cloned button
    const dynamicCheckoutButtons = document.querySelector(".cart__dynamic-checkout-buttons").cloneNode(true);

    // Append cloned elements to the sticky footer
    cartFooter.appendChild(totals);
    cartFooter.appendChild(footerCheckoutButton);
    cartFooter.appendChild(dynamicCheckoutButtons);
    document.body.appendChild(cartFooter);

    function checkButtonVisibility() {
        if (!checkoutButton) return;

        const rect = checkoutButton.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

        if (isVisible) {
            cartFooter.style.display = "none"; // Hide sticky footer if button is visible
        } else {
            cartFooter.style.display = "flex"; // Show sticky footer if button is off-screen
        }
    }

    // Check visibility on page load and while scrolling
    checkButtonVisibility();
    window.addEventListener("scroll", checkButtonVisibility);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saphir-mega-menu"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================================
     Saphir Mega Menu — SaphirSolution
     - hover mode is handled in CSS; JS adds click, keyboard and mobile
     - in the theme editor an opened panel stays open until another menu item
       is selected
     ========================================================================== */

  (function () {
    'use strict';

    var INSTANCES = [];

    function SaphirMegaMenu(root) {
      this.root = root;
      this.trigger = root.dataset.trigger || 'hover';
      this.mobileMode = root.dataset.mobile || 'accordion';
      this.breakpoint = parseInt(root.dataset.breakpoint, 10) || 990;
      this.designMode = root.dataset.designMode === 'true';
      this.items = Array.prototype.slice.call(root.querySelectorAll('[data-saphir-item]'));
      this.openItem = null;
      this.isMobile = false;

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.syncViewport = this.syncViewport.bind(this);

      this.init();
    }

    SaphirMegaMenu.prototype.init = function () {
      var self = this;

      this.items.forEach(function (item) {
        var panel = item.querySelector('[data-saphir-panel]');
        var trigger = item.querySelector('[data-saphir-trigger]');
        var grid = panel ? panel.querySelector('.saphir-mega__grid') : null;
        var hasPanel = !!(grid && grid.children.length > 0);

        item.dataset.hasPanel = hasPanel ? 'true' : 'false';

        if (!trigger) return;

        if (hasPanel) {
          trigger.setAttribute('aria-haspopup', 'true');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          trigger.removeAttribute('aria-haspopup');
          trigger.removeAttribute('aria-expanded');
        }

        trigger.addEventListener('click', function (event) {
          if (item.dataset.hasPanel !== 'true') return;

          var useClick = self.isMobile || self.trigger === 'click' || self.isTouch();
          if (!useClick) return;

          // First click opens, a second click follows the link (when there is one)
          if (!item.classList.contains('is-open')) {
            event.preventDefault();
            self.open(item);
          } else if (trigger.tagName !== 'A') {
            event.preventDefault();
            self.close(item);
          }
        });

        // Hovering away closes a panel that was opened by click.
        // Not in the theme editor, or it would keep collapsing while editing.
        item.addEventListener('mouseleave', function () {
          if (self.designMode) return;
          if (!self.isMobile && self.trigger === 'hover') self.close(item);
        });
      });

      this.drawer = new SaphirDrawer(this);

      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.syncViewport, { passive: true });

      this.syncViewport();
    };

    SaphirMegaMenu.prototype.isTouch = function () {
      return window.matchMedia('(hover: none)').matches;
    };

    SaphirMegaMenu.prototype.syncViewport = function () {
      var mobile = window.innerWidth <= this.breakpoint;
      if (mobile === this.isMobile) return;
      this.isMobile = mobile;
      this.root.classList.toggle('is-mobile', mobile);
      this.closeAll();
      /* leaving mobile with the drawer open would leave the page locked */
      if (!mobile && this.drawer) this.drawer.close();
    };

    SaphirMegaMenu.prototype.open = function (item) {
      if (!item || item.dataset.hasPanel !== 'true') return;
      if (this.openItem && this.openItem !== item) this.close(this.openItem);

      item.classList.add('is-open');
      var trigger = item.querySelector('[data-saphir-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      this.openItem = item;
    };

    SaphirMegaMenu.prototype.close = function (item) {
      if (!item) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-saphir-trigger]');
      if (trigger && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
      if (this.openItem === item) this.openItem = null;
    };

    SaphirMegaMenu.prototype.closeAll = function () {
      var self = this;
      this.items.forEach(function (item) {
        self.close(item);
      });
    };

    SaphirMegaMenu.prototype.onDocumentClick = function (event) {
      if (this.designMode) return;
      if (!this.openItem) return;
      if (this.root.contains(event.target)) return;
      this.closeAll();
    };

    SaphirMegaMenu.prototype.onKeydown = function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;

      if (this.drawer && this.drawer.isOpen) {
        /* one level at a time, like the back arrow — the last Escape closes */
        if (this.drawer.stack.length > 1) this.drawer.back();
        else this.drawer.close();
        return;
      }

      if (!this.openItem) return;
      var trigger = this.openItem.querySelector('[data-saphir-trigger]');
      this.closeAll();
      if (trigger) trigger.focus();
    };

    SaphirMegaMenu.prototype.destroy = function () {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.syncViewport);
    };


    /* ======================================================= Mobile drawer
       Builds its levels from the panels that are already in the page, every
       time it opens — so the drawer is never out of date, not even while the
       theme editor is changing blocks. */

    function SaphirDrawer(menu) {
      this.menu = menu;
      this.root = menu.root;
      this.el = this.root.querySelector('[data-saphir-drawer]');
      this.burger = this.root.querySelector('[data-saphir-burger]');
      this.body = this.el ? this.el.querySelector('[data-saphir-levels]') : null;
      this.head = this.el ? this.el.querySelector('.saphir-drawer__head') : null;
      this.backBtn = this.el ? this.el.querySelector('[data-saphir-back]') : null;
      this.backLabel = this.el ? this.el.querySelector('[data-saphir-back-label]') : null;
      this.brand = this.el ? this.el.querySelector('[data-saphir-brand]') : null;
      this.closeBtn = this.el ? this.el.querySelector('[data-saphir-close]') : null;
      this.brandHTML = this.brand ? this.brand.innerHTML : '';
      this.stack = [];
      this.isOpen = false;

      if (!this.el || !this.burger || !this.body) return;

      var self = this;
      this.burger.addEventListener('click', function () { self.toggle(); });
      if (this.closeBtn) this.closeBtn.addEventListener('click', function () { self.close(); });
      if (this.backBtn) this.backBtn.addEventListener('click', function () { self.back(); });
    }

    SaphirDrawer.prototype.usable = function () {
      return !!(this.el && this.burger && this.body);
    };

    /* ---------------------------------------------------------- building */

    SaphirDrawer.prototype.visible = function (node) {
      return !node.classList.contains('saphir-only-desktop');
    };

    SaphirDrawer.prototype.makeLevel = function (title, parent) {
      var level = document.createElement('div');
      level.className = 'saphir-level';
      level.dataset.title = title || '';
      this.body.appendChild(level);
      this.levels.push({ el: level, title: title || '', parent: parent || null });
      return level;
    };

    SaphirDrawer.prototype.rowElement = function (label, options) {
      var opts = options || {};
      var row = document.createElement(opts.href ? 'a' : 'button');
      row.className = 'saphir-row' + (opts.small ? ' saphir-row--small' : '');
      if (opts.href) {
        row.setAttribute('href', opts.href);
        if (opts.newTab) { row.setAttribute('target', '_blank'); row.setAttribute('rel', 'noopener'); }
      } else {
        row.setAttribute('type', 'button');
      }

      var text = document.createElement('span');
      text.className = 'saphir-row__label';
      text.textContent = label;
      row.appendChild(text);

      if (opts.badge) {
        var badge = opts.badge.cloneNode(true);
        row.appendChild(badge);
      }

      if (opts.chevron) {
        var chev = document.createElement('span');
        chev.className = 'saphir-row__chevron';
        chev.setAttribute('aria-hidden', 'true');
        chev.innerHTML = '<svg viewBox="0 0 6 10" width="7" height="11" focusable="false">' +
          '<path d="M1 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.5" ' +
          'stroke-linecap="round" stroke-linejoin="round"/></svg>';
        row.appendChild(chev);
      }

      return row;
    };

    /* A row that leads one level deeper. The level is built right away, so the
       whole tree exists before the first tap and nothing stutters. */
    SaphirDrawer.prototype.drillRow = function (label, sourceNodes, parentLevel, small) {
      var self = this;
      var sub = this.makeLevel(label, parentLevel);
      this.fill(sub, sourceNodes);

      var row = this.rowElement(label, { chevron: true, small: small });
      row.addEventListener('click', function () { self.goTo(sub); });
      return row;
    };

    SaphirDrawer.prototype.contentWrap = function (node) {
      var wrap = document.createElement('div');
      wrap.className = 'saphir-level__content';
      wrap.appendChild(node.cloneNode(true));
      return wrap;
    };

    /* Turns a list of source nodes into rows and content inside one level. */
    SaphirDrawer.prototype.fill = function (level, nodes) {
      var self = this;

      nodes.forEach(function (node) {
        if (!self.visible(node)) return;

        /* a column: with a heading it becomes a row, without one its contents
           are pulled up into this level */
        if (node.classList.contains('saphir-col')) {
          var heading = node.querySelector(':scope > .saphir-col__heading');
          var content = node.querySelector(':scope > .saphir-col__content');
          var footer = node.querySelector(':scope > .saphir-col__footer');
          var children = content ? Array.prototype.slice.call(content.children) : [];
          if (footer) children.push(footer);

          if (heading && children.length) {
            level.appendChild(self.drillRow(heading.textContent.trim(), children, level));
          } else {
            self.fill(level, children);
          }
          return;
        }

        /* a link list: with a group heading it becomes a row, without one its
           links land in this level */
        if (node.classList.contains('saphir-group')) {
          var groupHeading = node.querySelector(':scope > .saphir-group__heading');
          var links = Array.prototype.slice.call(node.querySelectorAll('.saphir-list__item'));
          if (groupHeading && links.length) {
            level.appendChild(self.drillRow(groupHeading.textContent.trim(), links, level));
          } else {
            self.fill(level, links);
          }
          return;
        }

        if (node.classList.contains('saphir-list__item')) {
          var link = node.querySelector('.saphir-list__link');
          if (!link) return;
          var labelEl = link.querySelector('.saphir-list__text');
          level.appendChild(self.rowElement(
            (labelEl || link).textContent.trim(),
            { href: link.getAttribute('href'), badge: link.querySelector('.saphir-list__badge') }
          ));
          return;
        }

        if (node.classList.contains('saphir-link')) {
          var linkLabel = node.querySelector('.saphir-link__label');
          level.appendChild(self.rowElement(
            (linkLabel || node).textContent.trim(),
            { href: node.getAttribute('href'), badge: node.querySelector('.saphir-link__badge') }
          ));
          return;
        }

        /* dividers are the panel's business, the drawer has its own rhythm */
        if (node.classList.contains('saphir-divider')) return;

        /* everything else — image, text, button, column footer — keeps its own
           markup and only gets the drawer's side padding */
        level.appendChild(self.contentWrap(node));
      });
    };

    SaphirDrawer.prototype.build = function () {
      this.body.innerHTML = '';
      this.levels = [];
      var self = this;
      var root = this.makeLevel('', null);
      this.rootLevel = root;

      var groups = { left: [], right: [], optional: [] };
      this.menu.items.forEach(function (item) {
        var key = item.dataset.group || 'left';
        if (!groups[key]) key = 'left';
        groups[key].push(item);
      });

      ['left', 'right', 'optional'].forEach(function (key) {
        if (!groups[key].length) return;
        var group = document.createElement('div');
        group.className = 'saphir-level__group';

        groups[key].forEach(function (item) {
          var trigger = item.querySelector('[data-saphir-trigger]');
          if (!trigger) return;
          var labelEl = trigger.querySelector('.saphir-mega__trigger-label');
          var label = (labelEl || trigger).textContent.trim();
          var grid = item.querySelector('.saphir-mega__grid');
          var columns = grid ? Array.prototype.slice.call(grid.children).filter(function (col) {
            return self.visible(col);
          }) : [];

          if (columns.length) {
            group.appendChild(self.drillRow(label, columns, root));
          } else {
            group.appendChild(self.rowElement(label, {
              href: trigger.getAttribute('href') || '#',
              badge: trigger.querySelector('.saphir-mega__badge')
            }));
          }
        });

        root.appendChild(group);
      });

      this.stack = [root];
      this.paint();
    };

    /* --------------------------------------------------------- navigating */

    SaphirDrawer.prototype.levelInfo = function (el) {
      for (var i = 0; i < this.levels.length; i++) {
        if (this.levels[i].el === el) return this.levels[i];
      }
      return null;
    };

    SaphirDrawer.prototype.paint = function () {
      var current = this.stack[this.stack.length - 1];
      var self = this;

      this.levels.forEach(function (entry) {
        var isCurrent = entry.el === current;
        var isBehind = self.stack.indexOf(entry.el) > -1 && !isCurrent;
        entry.el.classList.toggle('is-current', isCurrent);
        entry.el.classList.toggle('is-behind', isBehind);
      });

      var depth = this.stack.length;
      var info = this.levelInfo(current);
      var parentInfo = depth > 1 ? this.levelInfo(this.stack[depth - 2]) : null;
      this.el.dataset.depth = String(depth);

      if (this.backBtn) {
        this.backBtn.hidden = depth < 2;
        /* the first level has no title of its own, so it borrows the label
           that sits beside the burger */
        var parentTitle = parentInfo && parentInfo.title
          ? parentInfo.title
          : (this.el.dataset.rootLabel || '');
        if (this.backLabel) this.backLabel.textContent = depth > 1 ? parentTitle : '';
      }

      if (this.brand) {
        if (depth > 1 && info) {
          this.brand.textContent = info.title;
        } else {
          this.brand.innerHTML = this.brandHTML;
        }
      }

      current.scrollTop = 0;
    };

    SaphirDrawer.prototype.goTo = function (level) {
      this.stack.push(level);
      this.paint();
    };

    SaphirDrawer.prototype.back = function () {
      if (this.stack.length < 2) return;
      this.stack.pop();
      this.paint();
    };

    /* ------------------------------------------------------ open and close */

    SaphirDrawer.prototype.toggle = function () {
      if (this.isOpen) this.close(); else this.open();
    };

    SaphirDrawer.prototype.open = function () {
      if (!this.usable() || this.isOpen) return;
      this.build();
      this.el.hidden = false;
      /* one frame between "in the DOM" and "open", otherwise there is nothing
         to transition from */
      var el = this.el;
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      document.documentElement.classList.add('saphir-drawer-open');
      this.burger.setAttribute('aria-expanded', 'true');
      this.isOpen = true;
      if (this.closeBtn) this.closeBtn.focus();
    };

    SaphirDrawer.prototype.close = function () {
      if (!this.usable() || !this.isOpen) return;
      var el = this.el;
      el.classList.remove('is-open');
      document.documentElement.classList.remove('saphir-drawer-open');
      this.burger.setAttribute('aria-expanded', 'false');
      this.isOpen = false;
      window.setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 250);
      this.burger.focus();
    };

    function mount(scope) {
      var context = scope || document;
      var roots = Array.prototype.slice.call(context.querySelectorAll('[data-saphir-mega]'));
      roots.forEach(function (root) {
        if (root.saphirMegaMenu) return;
        root.saphirMegaMenu = new SaphirMegaMenu(root);
        INSTANCES.push(root.saphirMegaMenu);
      });
    }

    function unmount(scope) {
      INSTANCES = INSTANCES.filter(function (instance) {
        if (scope && !scope.contains(instance.root)) return true;
        instance.destroy();
        return false;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        mount();
      });
    } else {
      mount();
    }

    /* ---------------------------------------------------- Shopify theme editor */

    document.addEventListener('shopify:section:load', function (event) {
      mount(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      unmount(event.target);
    });

    function itemFor(target) {
      if (!target || !target.closest) return null;
      return target.closest('[data-saphir-item]');
    }

    function instanceFor(node) {
      var root = node && node.closest ? node.closest('[data-saphir-mega]') : null;
      return root ? root.saphirMegaMenu : null;
    }

    ['shopify:block:select', 'shopify:section:select'].forEach(function (name) {
      document.addEventListener(name, function (event) {
        var item = itemFor(event.target);
        var instance = instanceFor(event.target);
        if (!instance || !item) return;
        instance.open(item);
        item.scrollIntoView({ block: 'nearest' });
      });
    });

    /* No closing on deselect: in the editor the panel should stay open while
       its columns are being worked on. It only switches when another menu
       item is selected. */
  })();

  } catch(e) { console.error(e); }
})();
})();
